import axios from 'axios'
import cookies from 'js-cookie'

const carambolaUrl = process.env.REACT_APP_API_CARAMBOLA

/**
 * Instância dedicada e ISOLADA para telemetria.
 * De propósito NÃO usa o `api` principal: aquele tem um interceptor que faz
 * signOut() em 401. Aqui não há interceptor, então nenhuma falha da telemetria
 * pode deslogar o operador nem afetar o fluxo do app.
 */
const telemetryClient = axios.create({ timeout: 8000 })

export interface IClientLogEvent {
  /** Área do app que gerou o evento, ex.: 'conference', 'separation'. */
  area?: string
  /** O que aconteceu, ex.: 'scan', 'recovery_navegou'. */
  event: string
  [key: string]: unknown
}

/**
 * Telemetria "dispara e esquece" para diagnóstico de comportamento de tela.
 * Envia um evento para o backend (POST /client-event), que o registra no log -> Loki.
 *
 * Garantias (não travar / não quebrar o front):
 * - NÃO é aguardada: o chamador não dá `await`, então scan/navegação seguem na hora;
 * - erros de rede/4xx/5xx são engolidos — nunca chegam à tela;
 * - instância isolada, sem o interceptor que desloga em 401;
 * - navegação client-side (React Router) não cancela a requisição em andamento.
 */
export function clientLog(event: IClientLogEvent): void {
  try {
    telemetryClient
      .post(`${carambolaUrl}/client-event`, event, {
        headers: { Authorization: `Bearer ${cookies.get('authToken')}` },
      })
      .catch(() => undefined)
  } catch {
    /* telemetria nunca pode quebrar a tela */
  }
}
